<script>
import PopupModal from '@/components/modal/PopupModal.vue'
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import { auth as $store } from '@/store/AuthModule'
import RepairFileProspectService from '@/services/repairModule/repairFile/RepairFileProspectService'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'
import Validator from '@/components/utils/validator'

export default {
  name: 'AddProspectPictureByPCModal',
  components: { DialogCloseButton, PopupModal },
  data() {
    return {
      loading: false,

      currentRepairFile: null,

      newPictureList: [],

      error: null,

      validateButton: undefined,

      resolvePromise: undefined,
      rejectPromise: undefined
    }
  },
  computed: {
    filesMaximumCountRule() {
      return Validator.filesMaximumCountRule(this.currentRepairFile.prospect_picture_list.length, 6)
    }
  },
  methods: {
    async show(opts = {}) {
      this.currentRepairFile = opts.currentRepairFile

      this.loading = true
      try {
        this.$refs.popup.open()

        return new Promise((resolve, reject) => {
          this.resolvePromise = resolve
          this.rejectPromise = reject
        })
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async _reject() {
      this.error = {}
      this.newPictureList = []
      this.resolvePromise({
        confirmed: false
      })
      this.$refs.popup.close()
    },
    async sendNewPicture() {
      this.loading = true
      const repairFileId = this.currentRepairFile.technical_id
      try {
        const data = {
          repair_file_id: repairFileId,
          requestor_collaborator_id: $store.state.currentCollaborator.technical_id
        }
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))
        if (this.newPictureList && this.newPictureList.length > 0) {
          this.newPictureList.forEach((file, index) => {
            formData.append(`new_picture_list_${index}`, file)
          })
        }
        const response = await RepairFileProspectService.addNewPictureToRepairFileProspect(formData)

        if (response.key === 'valid_prospect_picture_added_with_error_key') {
          const splitResponse = response.message.split(':')
          const failedPhotoList = JSON.parse(splitResponse[splitResponse.length - 1]).join(', ')
          displayToast(
            this.$t('ERROR.VALID_PROSPECT_PICTURE_ADDED_WITH_ERROR', { photoList: failedPhotoList }),
            'warning'
          )
        } else {
          displayToast(
            this.$t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_PICTURE.ADD_SUCCESS'),
            'success'
          )
        }
        this.newPictureList = []
        this.$emit('refresh-repair-file')
        this.resolvePromise({
          confirmed: true
        })
        this.$refs.popup.close()
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <popup-modal ref="popup">
    <v-form ref="form" @submit.prevent="sendNewPicture">
      <DialogCloseButton :close-method="_reject" />

      <div>
        <div class="content-title">
          {{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.PICTURE_PC_MODAL.TITLE') }}
        </div>

        <div class="mt-8 mb-4 content detail-content">
          <p class="sub-title">
            {{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.PICTURE_MODAL.MESSAGE_1') }}
          </p>
        </div>

        <v-file-input
          class="mt-3 mb-4"
          :label="
            $t('STEP_PROSPECT.SUB_STEP_PROSPECT_REQUEST.RIGHT_PART.ADD_PICTURE.INPUT_LABEL_BY_PC')
          "
          accept=".jpg, .png"
          append-inner-icon="mdi-download"
          multiple
          chips
          counter
          show-size
          v-model="newPictureList"
          :rules="filesMaximumCountRule"
          :disabled="currentRepairFile.prospect_picture_list.length >= 6"
        />

        <!--Send button-->
        <div class="d-flex justify-center">
          <v-btn
            :disabled="
              newPictureList.length === 0 ||
              newPictureList.length > 6 - currentRepairFile.prospect_picture_list.length ||
              loading
            "
            :loading="loading"
            class="boom-button dialog-button"
            variant="outlined"
            type="submit"
          >
            {{ $t('COMMON.BUTTON.SAVE') }}
          </v-btn>
        </div>
      </div>
    </v-form>
  </popup-modal>
</template>

<style scoped>
.dialog-button {
  min-width: 200px;
}

.content-title {
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.content {
  display: flex;
  justify-content: center;
}

.detail-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.sub-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
